/*
 * @@Author: MuYang
 */
import { requestSchema, requestSubObjectsSchema } from './request'
import { requestI18Auth, findObjectAuthCode } from '../index'
import {
  OPERATION_CODE,
  CUSTOM_OBJECT_AUTH_CODE,
  LAYOUT_TYPE,
  HEADER_PARAMS_KEYS,
  FIELD_TYPE,
  PROJECT_CODE
} from '../constants'
import {updateDefaultField} from '../business/field-precision'
import { isUndefined, assign } from 'lodash'
import {processAbility} from '../business/ability'
import {batchQuoteFieldsHandle} from '../business/quote-field'
import processRelate from '../business/process-relate'
import {getBatchAuths} from '../business/auth'
// 创建 schema 之前
export async function beforeCreateSchema (bodyParams, headerParams = {}, config = {}) {
  const schemaMap = {}
  // 获取schema
  const schema = await requestSchema(bodyParams, headerParams)
  const {subPages = [], info} = schema.data
  schemaMap[info.objectApiName] = schema

  const _subArr = [] // 从对象
  const _resultArr = [] // 关联对象
  subPages.forEach(v => {
    if (v.subObjectParamName) {
      _subArr.push(v)
    } else {
      _resultArr.push(v)
    }
  })
  const allMenu = window.vueInstantiation.$store.state.user?.allMenu
  const path = window.vueInstantiation.$route.path
  // i18 + 权限
  await requestI18Auth({
    codeObjectApiname: allMenu?.[path]?.objApiName || info.objectApiName,
    objectApiName: info.objectApiName,
    subs: _subArr.map(v => v.objectApiName).concat(batchRelateObject([schema])),
    region: info.region
  })

  // 更新默认字段的数据
  // 数字金额字段获取系统配置的精度
  await updateDefaultField()

  // 重置关联关系Map
  processRelate.reset()

  // 获取当前页面对应code
  const code = info.type === LAYOUT_TYPE.LAYOUT_TYPE_UPDATE ? OPERATION_CODE.UPDATE : (info.type === LAYOUT_TYPE.LAYOUT_TYPE_DETAIL ? LAYOUT_TYPE.LAYOUT_TYPE_DETAIL : OPERATION_CODE.CREATE)
  // 过滤无权从对象
  _subArr.forEach((sub) => {
    if (findObjectAuthCode(sub.objectApiName, config[sub.objectApiName]?.authCode?.[code] || CUSTOM_OBJECT_AUTH_CODE[code])) {
      _resultArr.push(sub)
    } else {
      _resultArr.push(sub)
    }
  })
  schema.data.subPages = _resultArr
  // 获取从对象
  if (_resultArr.length === 0) {
    // 获取能力追加到schema中
    await processAbility(schema)
    // 获取引用字段的引用字段信息
    await batchQuoteFieldsHandle({schema})
    return {schema}
  }
  // 从对象处理
  const subSchema = await getSubSchema(bodyParams, headerParams, _resultArr, info.type)
  // 获取能力追加到schema中
  await processAbility(schema, subSchema)
  // 获取引用字段的引用字段信息
  await batchQuoteFieldsHandle({schema, subSchema})
  // 获取主从全部schema中的查找关联字段关联的对象权限 (判断关联列表的列表权)
  await getBatchAuths(batchRelateObject([schema].concat(subSchema)), {})
  return {
    schema,
    subSchema
  }
}

// 从对象
async function getSubSchema (params, headerParams, subs, parentLayoutType) {
  delete headerParams[HEADER_PARAMS_KEYS.operationApiName]
  const tasks = subs.map(sub => {
    const _params = assign({parentLayoutType}, params, sub)
    return requestSubObjectsSchema(_params, headerParams)
  })
  const res = await Promise.all(tasks)
  return res.filter(v => !isUndefined(v))
}

// 查找关联关联对象
function batchRelateObject (schemas = []) {
  const objectApiNames = []
  for (let s of schemas) {
    const {data: {fields} = []} = s
    for (let v of fields) {
      // 查找关联字段关联列表筛选
      if (v.type === FIELD_TYPE.LOOKUP_RELATION) {
        const relationPage = (v.appRelationPageVOS || []).find(k => k.tenantType === PROJECT_CODE)
        if (relationPage) {
          objectApiNames.push(relationPage.relateObjectApiName)
        }
      }
    }
  }
  return objectApiNames
}
